import { render, staticRenderFns } from "./PreparationTime.vue?vue&type=template&id=370fa497&"
import script from "./PreparationTime.vue?vue&type=script&lang=js&"
export * from "./PreparationTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports